import tw from 'tailwind.macro';

export const AvatarContainer = tw.div`cursor-pointer`;
export const AvatarImage = tw.img`rounded-full w-8 h-8`;

export const Initials = tw.div`
w-8 h-8 flex-shrink-0 rounded-full inline-flex items-center justify-center text-white relative z-10
`;
